export let __biz_start_time__ = Date.now();
export function setBizStartTime(bizStartTime: number) {
    __biz_start_time__ = bizStartTime;
}

let orderMainHasLoaded = false;
export function setOrderMainHasLoaded(newOrderMainHasLoaded: boolean) {
    orderMainHasLoaded = newOrderMainHasLoaded;
}

export function getOrderMainHasLoaded() {
    return orderMainHasLoaded;
}
